export default "__VITE_ASSET__BK7aEQzP__"